export default function getMetaWithTranslations(meta, language) {
    return meta?.map((item) => ({
        [item.attribute]: item.name,
        content: item.translations.find(
            (translation) => translation.language === language
        )?.content,
    }));
}
